import React, { FC, ReactNode } from 'react';
import styles from './Tabs.module.scss';
import Tab from './tab/Tab';
interface TabProps {
  value: string;
  label: string;
  isActive?: boolean;
  onClick?: () => void;
}
interface TabsProps {
  value: string;
  onChange: (value: string) => void;
  children: ReactNode;
  className?: string;
  data_cy?: string;
  id?: string;
}
const Tabs: FC<TabsProps> = ({
  value,
  onChange,
  children,
  className = '',
  data_cy,
  id
}) => {
  return <div className={styles['tabs'] + ' ' + className} data-cy={data_cy} id={id} data-sentry-component="Tabs" data-sentry-source-file="Tabs.tsx">
      {React.Children.map(children, child => {
      if (React.isValidElement<TabProps>(child)) {
        return React.cloneElement(child, {
          isActive: child.props.value === value,
          onClick: () => onChange(child.props.value)
        });
      }
      return null;
    })}
    </div>;
};
export default Tabs;
export { Tab };